interface IconProps {
  fillColor: string
}

export const HeartIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40 8C57.6731 8 72 22.3269 72 40C72 57.6731 57.6731 72 40 72C22.3269 72 8 57.6731 8 40C8 22.3269 22.3269 8 40 8ZM40 10.2669C23.5787 10.2669 10.2669 23.5787 10.2669 40C10.2669 56.4213 23.5787 69.7331 40 69.7331C56.4213 69.7331 69.7331 56.4213 69.7331 40C69.7331 23.5787 56.4213 10.2669 40 10.2669Z"
          fill={fillColor}
        />
        <path
          d="M56.2005 36.9661C56.2002 31.8527 52.2599 27.7998 47.5117 27.7995C44.8672 27.7995 42.4864 29.0485 40.8828 31.043L40 32.1406L39.1172 31.043C37.5136 29.0485 35.1328 27.7995 32.4883 27.7995C27.7401 27.7998 23.7998 31.8527 23.7995 36.9661C23.7995 41.0283 25.961 43.9765 29.2708 46.9258C30.9328 48.4067 32.8216 49.8344 34.8216 51.3997C36.5333 52.7394 38.3069 54.166 40 55.7591C41.6931 54.166 43.4667 52.7394 45.1784 51.3997C47.1784 49.8344 49.0672 48.4067 50.7292 46.9258C54.039 43.9765 56.2005 41.0283 56.2005 36.9661ZM58.4661 36.9661C58.4661 42.0007 55.716 45.5184 52.237 48.6185C50.5047 50.1621 48.5294 51.6557 46.5755 53.1849C44.6042 54.7278 42.625 56.3275 40.7969 58.138L40 58.9284L39.2031 58.138C37.375 56.3275 35.3958 54.7278 33.4245 53.1849C31.4706 51.6557 29.4953 50.1621 27.763 48.6185C24.284 45.5184 21.5339 42.0007 21.5339 36.9661C21.5342 30.7035 26.388 25.5342 32.4883 25.5339C35.4062 25.5339 38.0457 26.7265 40 28.6497C41.9543 26.7265 44.5938 25.5339 47.5117 25.5339C53.612 25.5342 58.4658 30.7035 58.4661 36.9661Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
